let navigate = undefined;
export const setNavigate = (useNavig) => {
  navigate = useNavig;
};
export const redirectTo = (path) => {
  navigate(path);
};
